import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function types(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_TYPES_LIST":
			return update(state, { list: { $set: action.types } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/types/reducer.js